export default __webpack_public_path__ + "static/media/polls.bb9d1806.svg";